import React, { createContext, useState } from 'react'
import Notification, { NotificationItem } from './Notification.tsx'
import { createUUID } from '@/common/utilities.ts'

type NotificationContextType = {
  addNotification: (message: string) => void
}

export const NotificationContext = createContext<
  NotificationContextType | undefined
>(undefined)

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [notifications, setNotifications] = useState<NotificationItem[]>([])

  const addNotification = (message: string) => {
    setNotifications((prev) => {
      const isDuplicate = prev.some(
        (notification) => notification.message === message
      )
      if (isDuplicate) return prev

      const id = createUUID() // Generate the ID once
      const newNotification = { id, message }
      setTimeout(() => {
        setNotifications((prev) =>
          prev.filter((notification) => notification.id !== id)
        )
      }, 6000)

      return [...prev, newNotification]
    })
  }

  const removeNotification = (id: string) => {
    setNotifications((prev) =>
      prev.filter((notification) => notification.id !== id)
    )
  }

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      <Notification
        notifications={notifications}
        removeNotification={removeNotification}
      />
    </NotificationContext.Provider>
  )
}
